import {
  ROUTE,
  ROUTE_PATH
} from 'modules/routes/constants/index.cjs'
import loadSectionAction from 'modules/section/actions/load'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'
import getQuerySearchSelect from 'modules/search/selectors/get-query'
import loadRecommendedPlansAction from 'modules/plan/redux/actions/load-recommended'
import loadRecommendedWorkoutsAction from 'modules/workout/redux/actions/load-recommended'
import { loadExercisesAction } from '@gymaholic/packages'
import { logUtil } from 'packages/src'

const CATEGORY_TO_ROUTE_PATH = {
  [SECTIONS_NAME.ARTICLES]: ROUTE_PATH.ARTICLES,
  [SECTIONS_NAME.MOTIVATION]: ROUTE_PATH.MOTIVATION,
  exercises: ROUTE_PATH.EXERCISES,
  workouts: ROUTE_PATH.WORKOUTS,
  plans: ROUTE_PATH.PLANS
  // [SECTIONS_NAME.STORE]: ROUTE_PATH.STORE,
  // [SECTIONS_NAME.PAGES]: ROUTE_PATH.PAGES
}

function loadSection (route, match, options) {
  return (dispatch, getState) => {
    const query = getQuerySearchSelect(getState())
    const debugProps = {
      route,
      match,
      options
    }
    logUtil('loadSection').debug('debugProps=', debugProps)
    if (!query.length) {
      logUtil('loadSection').debug('[noop] no query')
      return
    }

    // Even if some items are loaded but doesn't match the query
    // Force the loading
    options = {
      ...options,
      isFromSearchPage: true,
      query: {
        ...(
          options.query || {}
        ),
        limit: 10
      },
      isForced: true
    }
    return dispatch(
      loadSectionAction(route, match, options)
    )
  }
}

export default function loadSearchAction (route, match, options = {}) {
  return (dispatch, getState) => {
    // If the query is too small, no-op
    const query = getQuerySearchSelect(getState())

    // Add the query to the options
    options = {
      ...options,
      query: {
        query
      }
    }

    const loadExercises = () => {
      return dispatch(loadExercisesAction(query))
    }
    const loadPlans = () => dispatch(loadRecommendedPlansAction({ ignoreTag: true }))
    const loadWorkouts = () => dispatch(loadRecommendedWorkoutsAction({ ignoreTag: true }))
    // If a category is active, load it
    // e.g. '/search/articles'
    const category = match?.params?.category
    if (category === 'exercises') {
      return loadExercises()
    }
    if (category === 'plans') {
      return loadPlans()
    }
    if (category === 'workouts') {
      return loadWorkouts()
    }

    if (match.params.category) {
      const route = ROUTE[CATEGORY_TO_ROUTE_PATH[category]]
      return dispatch(loadSection(route, match, options))
    }

    return Promise.all([
      dispatch(
        loadSection(
          ROUTE[ROUTE_PATH.ARTICLES],
          match,
          options
        )
      ),
      dispatch(
        loadSection(
          ROUTE[ROUTE_PATH.MOTIVATION],
          match,
          options
        )
      ),
      loadExercises(),
      loadPlans(),
      loadWorkouts()
      // dispatch(
      //   loadSection(
      //     ROUTE[ROUTE_PATH.STORE],
      //     match,
      //     options
      //   )
      // ),
      // dispatch(
      //   loadSection(
      //     ROUTE[ROUTE_PATH.PAGES],
      //     match,
      //     options
      //   )
      // )
    ])
  }
}
